import { render, staticRenderFns } from "./dashboardTijianjigoufeiyong.vue?vue&type=template&id=16beef9d&scoped=true"
import script from "./dashboardTijianjigoufeiyong.vue?vue&type=script&lang=js"
export * from "./dashboardTijianjigoufeiyong.vue?vue&type=script&lang=js"
import style0 from "./dashboardTijianjigoufeiyong.vue?vue&type=style&index=0&id=16beef9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16beef9d",
  null
  
)

export default component.exports